






























































import { Component, Provide, VModel, Watch } from "vue-property-decorator";
import GuardileoFormElement from "@/components/GuardileoFormElement.vue";
import GuardileoFormGroupRow from "@/components/GuardileoFormGroupRow.vue";
import Vorfallmanagement from "../api/Vorfallmanagement";
import IcsButton from "@/components/IcsButton.vue";
import GuardileoCheckbox from "@/Drittlandtransferpruefung/GuardileoCheckbox.vue";
import SubTabErfMeldungBehoerdeVfmt from "../subtabs/RechtlicheBeurteilung/SubTab-ErfMeldungBehoerde-vfmt.vue";
import SubTabErfBenachrichtigungPersonenVfmt from "../subtabs/RechtlicheBeurteilung/SubTab-ErfBenachrichtigungPersonen-vfmt.vue";
import VorfallmanagementDefaultDaten from "../api/Default-Daten-vfmt";
import VorfallmanagementApi from "../api/api-vfmt";
import { TabBaseVfmt } from "./Tab-Base-vfmt";

@Component({
  components: {
    GuardileoFormElement,
    GuardileoFormGroupRow,
    IcsButton,
    GuardileoCheckbox,
    SubTabErfMeldungBehoerdeVfmt,
    SubTabErfBenachrichtigungPersonenVfmt,
  },
})
export default class extends TabBaseVfmt {
  @Provide() private readonly TabIndex: number = 2;
  private relevantKeys: (keyof Vorfallmanagement.RechtlicheBeurteilung)[] = [
    "ErforderlichkeitDerMeldungBegruendung",
    "IstMeldungErfoderlich",
    "ErforderlichkeitDerBenachrichtungBegruendung",
    "IstBenachrichtigungErfoderlich",
  ];

  public loadingLeitlinie: boolean = false;
  public leitlinie: Vorfallmanagement.Leitlinie =
    VorfallmanagementDefaultDaten.Leitlinie();

  async loadLeitlinie() {
    try {
      this.loadingLeitlinie = true;
      const resp = await this.api.GetLeitlinien();
      if (resp && resp.length > 0) {
        const reversed = [...resp].reverse();
        this.leitlinie = reversed[0];
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.loadingLeitlinie = false;
    }
  }

  @Watch("vorfall.RechtlicheBeurteilungen", { deep: true })
  checkChanges() {
    if (this.vorfall && this.vorfallClone) {
      const lastIndex = this.vorfall.RechtlicheBeurteilungen.length - 1;
      let lastOrig = [...this.vorfall.RechtlicheBeurteilungen][lastIndex];
      let lastClone = [...this.vorfallClone.RechtlicheBeurteilungen][lastIndex];
      if (lastOrig && lastClone) {
        const changes = this.relevantKeys.filter(
          (key) => lastOrig[key] !== lastClone[key]
        );
        this.hasChanged = [changes.length > 0];
      }
    }
  }

  private get hatNachmeldung() {
    return this.vorfall && this.vorfall.HatNachmeldung;
  }

  async save_changes(event: any) {
    event.preventDefault();
    try {
      if (this.vorfall) {
        await this.guard_save(() =>
          this.api.RechtlicheBeurteilungSpeichern(this.vorfall!)
        );
      }
    } catch (error) {
      throw error;
    }
  }

  get istEingeschraenkt() {
    return (
      !this.hat_Berechtigung("Vorfallmanagement_Vorfall_bearbeiten_voll") &&
      this.hat_Berechtigung(
        "Vorfallmanagement_Vorfall_bearbeiten_eingeschraenkt"
      )
    );
  }

  created() {
    this.loadLeitlinie();
  }
}
